import React from "react";
import ElectricityConsumptionByFacility from "./ConsumptionByEquipment";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope2Layout from "../../../../Layout/Scope2Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const SteamFacility = () => {
  return (
    <MainDashboardLayout sidebar={<Scope2Layout />}>
      <Unauthorized requiredModule="Environment | Scope 2 | Steam">
        <ElectricityConsumptionByFacility />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default SteamFacility;
